import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { StepContext } from "../../hooks/StepContext";
import { OrderContext } from "../../hooks/OrderContext";
import { Sidebar } from '../../capture-service-review/mp-capture-service-review';
export default function SidebarWrapper() {
    var step = useContext(StepContext).step;
    var order = useContext(OrderContext).order;
    return _jsx(Sidebar, { order: order, step: step });
}
